/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingMetricSourceOverride {
    getFixupPrototypeFunction() { return BillingMetricSourceOverride.fixupPrototype; }

    static newInstance(model: Partial<BillingMetricSourceOverride>): BillingMetricSourceOverride {
        let obj = Object.assign(new BillingMetricSourceOverride(), model);
        BillingMetricSourceOverride.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingMetricSourceOverride>): BillingMetricSourceOverride {
        if (!model) return null;
        return BillingMetricSourceOverride.newInstance(<BillingMetricSourceOverride> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingMetricSourceOverride) {
        if (!obj) return;

        models.BillingMetricSourceOverride.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingMetricSourceOverride): boolean {
        Object.setPrototypeOf(obj, BillingMetricSourceOverride.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.native_details) {
            for (let val of this.native_details) {
                models.ServiceAccountNativeDetailsBase.fixupPrototype(val);
            }
        }
    }

    native_details: Array<models.ServiceAccountNativeDetailsBase>;

    /**
     * ID of the metric to override
     */
    source_metric_id: string;

}
